<template functional>
  <i
    :class="{
      'el-icon-check':
        props.row[props.column] === 1 || props.row[props.column] === true,
      'el-icon-close':
        props.row[props.column] === 0 || props.row[props.column] === false
    }"
    :style="{ color: props.row[props.column] === true ? 'green' : 'red' }"
  >
  </i>
</template>

<script>
export default {
  name: "RenderCheck"
};
</script>

<style></style>
